import { create, group, skipWhen } from "vest";

import { MANAGED_CARE_PAYMENT_SOURCE } from "constants/patients";
import {
  dateIsValid,
  emailIsValid,
  nameIsValid,
  phoneIsValid,
  required,
  requiredAndNameIsValid,
  zipCodeIsValid
} from "utils/validations.utils";

import { PatientFormValues } from "./patient-form.component";

export type PatientDetailsFieldName =
  | "first_name"
  | "middle_name"
  | "last_name"
  | "birthdate"
  | "birthdate_not_provided"
  | "referral_source"
  | "sub_referral_source"
  | "sub_referral_source_object"
  | "payment_source_type"
  | "phone"
  | "email"
  | "preferred_communication_method"
  | "phone_type"
  | "managed_care_plan"
  | "sex"
  | "zip_code"
  | "country"
  | "gender"
  | "gender_other"
  | "sub_referral_source_required";

export const patientFormValidator = (
  isReferralSourceRequired: boolean = false,
  isSexRequired: boolean = false,
  isSubReferralSourceRequired: boolean = false
) =>
  create((data: PatientFormValues) => {
    const {
      first_name,
      middle_name,
      last_name,
      birthdate,
      birthdate_not_provided,
      phone,
      email,
      preferred_communication_method,
      phone_type,
      payment_source_type,
      managed_care_plan,
      referral_source,
      sub_referral_source,
      sub_referral_source_object,
      sex,
      zip_code,
      country,
      sub_referral_source_required
    } = data;

    skipWhen(
      payment_source_type !== String(MANAGED_CARE_PAYMENT_SOURCE),
      () => {
        required<PatientDetailsFieldName>(
          "managed_care_plan",
          "Managed Care Plan",
          managed_care_plan
        );
      }
    );

    skipWhen(!isReferralSourceRequired, () => {
      required<PatientDetailsFieldName>(
        "referral_source",
        "Referral Source",
        referral_source
      );
    });

    if (isSubReferralSourceRequired && sub_referral_source_required) {
      required<PatientDetailsFieldName>(
        "sub_referral_source",
        "Sub Referral Source",
        sub_referral_source || sub_referral_source_object
      );
    }

    skipWhen(!isSexRequired, () => {
      required<PatientDetailsFieldName>("sex", "Sex", sex);
    });

    requiredAndNameIsValid<PatientDetailsFieldName>(
      "first_name",
      "First Name",
      first_name
    );

    nameIsValid<PatientDetailsFieldName>(
      "middle_name",
      "Middle Name",
      middle_name
    );

    requiredAndNameIsValid<PatientDetailsFieldName>(
      "last_name",
      "Last Name",
      last_name
    );
    required<PatientDetailsFieldName>("last_name", "Last Name", last_name);

    group("birthdateGroup", () => {
      if (!birthdate_not_provided) {
        dateIsValid<PatientDetailsFieldName>(
          "birthdate",
          "Date of Birth",
          birthdate
        );
      }
    });

    required<PatientDetailsFieldName>(
      "phone_type",
      "Type of Phone number",
      phone_type
    );
    required<PatientDetailsFieldName>(
      "preferred_communication_method",
      "Preferred Communication method",
      preferred_communication_method
    );
    required<PatientDetailsFieldName>("phone", "Phone Number", phone);
    phoneIsValid<PatientDetailsFieldName>("phone", "Phone Number", phone);
    emailIsValid<PatientDetailsFieldName>("email", "Email", email);
    zipCodeIsValid<PatientDetailsFieldName>(
      "zip_code",
      "ZIP Code",
      zip_code,
      country
    );
  });
